import {
	CAR_GIFT_PASSWORD_VERIFY_CODE,
	CAR_GIFT_PASSWORD_VERIFY_POINTS,
	CAR_LOG_PASSWORD_VERIFY_CODES,
	CAR_LOG_PASSWORD_VERIFY_POINTS,
	CAR_SHAKE_PASSWORD_VERIFY_CODE
} from '../api/config.js'
import { cvQuery } from '../utils/dom.js'
import { isPendingVerify, submitCarShakePasswordVerify } from './shake-lottery.js'

export const PWD_HOTSPOT_KIND = {
	SHAKE: 'shake',
	LOG: 'log',
	GIFT: 'gift'
}

const LOG_POINT_BY_PASSWORD = {
	[CAR_LOG_PASSWORD_VERIFY_CODES.one]: 'one',
	[CAR_LOG_PASSWORD_VERIFY_CODES.three]: 'three'
}

let ui = {
	setHotspots: null,
	openDialog: null,
	closeDialog: null
}

let checkinHandlers = {
	isLogPointAvailable: function () {
		return false
	},
	isGiftAvailable: function () {
		return false
	},
	submitLogPoint: async function () {},
	submitGift: async function () {}
}

export function initPasswordHotspotCodes() {}

export function registerPasswordCheckinHandlers(handlers) {
	if (!handlers || typeof handlers !== 'object') return
	if (typeof handlers.isLogPointAvailable === 'function') {
		checkinHandlers.isLogPointAvailable = handlers.isLogPointAvailable
	}
	if (typeof handlers.isGiftAvailable === 'function') {
		checkinHandlers.isGiftAvailable = handlers.isGiftAvailable
	}
	if (typeof handlers.submitLogPoint === 'function') {
		checkinHandlers.submitLogPoint = handlers.submitLogPoint
	}
	if (typeof handlers.submitGift === 'function') {
		checkinHandlers.submitGift = handlers.submitGift
	}
	syncAllPasswordHotspots()
}

export function registerCarPasswordHotspotUi(api) {
	ui =
		api && typeof api === 'object'
			? api
			: { setHotspots: null, openDialog: null, closeDialog: null }
	syncAllPasswordHotspots()
}

export function unregisterCarPasswordHotspotUi() {
	closePasswordDialog()
	if (typeof ui.setHotspots === 'function') {
		ui.setHotspots({
			shake: false,
			log: false,
			gift: false
		})
	}
	ui = { setHotspots: null, openDialog: null, closeDialog: null }
}

function closePasswordDialog() {
	if (typeof ui.closeDialog === 'function') {
		ui.closeDialog()
	}
}

function isOnSlide(index) {
	const swiper = window.__carvueSwiper
	return !!(swiper && swiper.activeIndex === index)
}

function isHomeCheckOverlayVisible() {
	const overlay = cvQuery('#homeCheck')
	if (!overlay) return false
	if (!overlay.hidden) return true
	return overlay.classList.contains('is-show')
}

function shouldShowShakeHotspot() {
	if (!isOnSlide(0)) return false
	if (isHomeCheckOverlayVisible()) return false
	return isPendingVerify()
}

function shouldShowLogHotspot() {
	if (!isOnSlide(1)) return false
	return (
		checkinHandlers.isLogPointAvailable('one') ||
		checkinHandlers.isLogPointAvailable('three')
	)
}

function resolveLogPointByPassword(password) {
	const pwd = String(password || '').trim()
	return LOG_POINT_BY_PASSWORD[pwd] || ''
}

function cloneVerifyPoints(points) {
	return points.map(function (p) {
		return p.slice()
	})
}

function shouldShowGiftHotspot() {
	if (!isOnSlide(2)) return false
	return checkinHandlers.isGiftAvailable()
}

export function shouldShowPasswordHotspot(kind) {
	if (kind === PWD_HOTSPOT_KIND.SHAKE) return shouldShowShakeHotspot()
	if (kind === PWD_HOTSPOT_KIND.LOG) return shouldShowLogHotspot()
	if (kind === PWD_HOTSPOT_KIND.GIFT) return shouldShowGiftHotspot()
	return false
}

export function syncAllPasswordHotspots() {
	const show = {
		shake: shouldShowShakeHotspot(),
		log: shouldShowLogHotspot(),
		gift: shouldShowGiftHotspot()
	}
	if (!show.shake && !show.log && !show.gift) {
		closePasswordDialog()
	}
	if (typeof ui.setHotspots === 'function') {
		ui.setHotspots(show)
	}
}

export function openPasswordDialog(kind) {
	if (!shouldShowPasswordHotspot(kind)) return
	if (typeof ui.openDialog === 'function') {
		ui.openDialog(kind)
	}
}

export async function submitPasswordByKind(kind, password) {
	const pwd = String(password || '').trim()
	const { showToast } = await import('../api/public.js')
	if (kind === PWD_HOTSPOT_KIND.SHAKE) {
		if (pwd !== CAR_SHAKE_PASSWORD_VERIFY_CODE) {
			showToast('error', '密码错误')
			return
		}
		await submitCarShakePasswordVerify(password)
		syncAllPasswordHotspots()
		return
	}
	if (kind === PWD_HOTSPOT_KIND.LOG) {
		const legacyPoint = resolveLogPointByPassword(pwd)
		if (!legacyPoint) {
			showToast('error', '密码错误')
			return
		}
		if (!checkinHandlers.isLogPointAvailable(legacyPoint)) {
			showToast('info', '该打卡点已完成或不可打卡')
			return
		}
		const points = cloneVerifyPoints(CAR_LOG_PASSWORD_VERIFY_POINTS[legacyPoint])
		await checkinHandlers.submitLogPoint(legacyPoint, points)
		syncAllPasswordHotspots()
		return
	}
	if (kind === PWD_HOTSPOT_KIND.GIFT) {
		if (pwd !== CAR_GIFT_PASSWORD_VERIFY_CODE) {
			showToast('error', '密码错误')
			return
		}
		if (!shouldShowGiftHotspot()) {
			showToast('info', '当前不可核销')
			return
		}
		await checkinHandlers.submitGift(cloneVerifyPoints(CAR_GIFT_PASSWORD_VERIFY_POINTS))
		syncAllPasswordHotspots()
	}
}
